import React from 'react'
const CommentsList = ({ comments }) => {
    return (
        <div className="bg-white shadow-md border max-w-5xl p-10 mx-auto mb-20" style={{boxShadow:'0 0 0 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0), 4px 14px 24px 0px rgba(0, 0, 0, 0.15)'}}>
            <h2 className="text-base font-semibold text-gray-900 p-4 border-b border-gray-200">{comments.length} Comments</h2>
            <div className="divide-y divide-gray-200">
                {comments.map((comment, index) => (
                    <div key={index} className="flex items-start gap-3 p-4">
                        <img
                            src={comment.avatar}
                            alt={`${comment.name}'s avatar`}
                            className="w-14 h-15 object-cover flex-shrink-0"
                        />
                        <div>
                            <h3 className="text-base font-semibold text-blue-800">{comment.name}</h3>
                            <p className="text-base text-gray-600 mt-0.5">{comment.content}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CommentsList
